export default __webpack_public_path__ + "static/media/carousell.9db50edc.svg";